import { useMediaState } from '@platejs/media/react';
import { ResizableProvider } from '@platejs/resizable';
import type { TAudioElement } from 'platejs';
import type { PlateElementProps } from 'platejs/react';
import { PlateElement, withHOC } from 'platejs/react';
import { cn } from 'src/lib/utils';

export const AudioElement = withHOC(
  ResizableProvider,
  function AudioElement(props: PlateElementProps<TAudioElement>) {
    const { unsafeUrl } = useMediaState();

    return (
      <PlateElement {...props} className="mb-1">
        <figure className="group relative cursor-default" contentEditable={false}>
          <div className={cn('h-16 rounded-sm')}>
            {/* Uploaded audio has no caption file; the empty track satisfies the captions requirement. */}
            <audio className="size-full" src={unsafeUrl} controls>
              <track kind="captions" />
            </audio>
          </div>
        </figure>
        {props.children}
      </PlateElement>
    );
  },
);
